export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mobile-instruction.vue?vue&type=template&id=7d510756"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/mobile-instruction/mobile-instruction.vue?vue&type=template&id=7d510756
// module id = TrZP
// module chunks = 0